import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import IncomeSourceDetailListComponent from './IncomeSourceDetailListComponent';
import { Card, IconButton } from '@totalsoft/rocket-ui';
import Details from '@mui/icons-material/PlaylistAdd';
import CardNoResultsWrapper from 'components/layout/CardNoResultsWrapper';

const IncomeSourceDetailListCard = ({ incomeItemDetails, periodTypes, dataTypes, dispatch, onSave, validation }) => {
  const { t } = useTranslation();

  const onAddNewDetail = () => {
    dispatch({
      type: 'OnDetailAdded'
    });
  };

  return (
    <Card
      icon={Details}
      iconColor='primary'
      title={t('IncomeSources.Details')}
      actions={<IconButton type='add' fontSize='medium' color='transparent' tooltip={t('Tooltips.Add')} onClick={onAddNewDetail} />}
    >
      <CardNoResultsWrapper content={incomeItemDetails}>
        <IncomeSourceDetailListComponent
          incomeItemDetails={incomeItemDetails}
          dispatch={dispatch}
          periodTypes={periodTypes}
          dataTypes={dataTypes}
          onSave={onSave}
          validation={validation}
        />
      </CardNoResultsWrapper>
    </Card>
  );
};

IncomeSourceDetailListCard.propTypes = {
  dispatch: PropTypes.func.isRequired,
  incomeItemDetails: PropTypes.array.isRequired,
  periodTypes: PropTypes.array,
  dataTypes: PropTypes.array,
  onAddNewDetail: PropTypes.func,
  onSave: PropTypes.func.isRequired,
  validation: PropTypes.object
};

export default IncomeSourceDetailListCard;
